"use strict";

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return r; }; var t, r = {}, e = Object.prototype, n = e.hasOwnProperty, o = "function" == typeof Symbol ? Symbol : {}, i = o.iterator || "@@iterator", a = o.asyncIterator || "@@asyncIterator", u = o.toStringTag || "@@toStringTag"; function c(t, r, e, n) { return Object.defineProperty(t, r, { value: e, enumerable: !n, configurable: !n, writable: !n }); } try { c({}, ""); } catch (t) { c = function c(t, r, e) { return t[r] = e; }; } function h(r, e, n, o) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype); return c(a, "_invoke", function (r, e, n) { var o = 1; return function (i, a) { if (3 === o) throw Error("Generator is already running"); if (4 === o) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var u = n.delegate; if (u) { var c = d(u, n); if (c) { if (c === f) continue; return c; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (1 === o) throw o = 4, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = 3; var h = s(r, e, n); if ("normal" === h.type) { if (o = n.done ? 4 : 2, h.arg === f) continue; return { value: h.arg, done: n.done }; } "throw" === h.type && (o = 4, n.method = "throw", n.arg = h.arg); } }; }(r, n, new Context(o || [])), !0), a; } function s(t, r, e) { try { return { type: "normal", arg: t.call(r, e) }; } catch (t) { return { type: "throw", arg: t }; } } r.wrap = h; var f = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var l = {}; c(l, i, function () { return this; }); var p = Object.getPrototypeOf, y = p && p(p(x([]))); y && y !== e && n.call(y, i) && (l = y); var v = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(l); function g(t) { ["next", "throw", "return"].forEach(function (r) { c(t, r, function (t) { return this._invoke(r, t); }); }); } function AsyncIterator(t, r) { function e(o, i, a, u) { var c = s(t[o], t, i); if ("throw" !== c.type) { var h = c.arg, f = h.value; return f && "object" == typeof f && n.call(f, "__await") ? r.resolve(f.__await).then(function (t) { e("next", t, a, u); }, function (t) { e("throw", t, a, u); }) : r.resolve(f).then(function (t) { h.value = t, a(h); }, function (t) { return e("throw", t, a, u); }); } u(c.arg); } var o; c(this, "_invoke", function (t, n) { function i() { return new r(function (r, o) { e(t, n, r, o); }); } return o = o ? o.then(i, i) : i(); }, !0); } function d(r, e) { var n = e.method, o = r.i[n]; if (o === t) return e.delegate = null, "throw" === n && r.i.return && (e.method = "return", e.arg = t, d(r, e), "throw" === e.method) || "return" !== n && (e.method = "throw", e.arg = new TypeError("The iterator does not provide a '" + n + "' method")), f; var i = s(o, r.i, e.arg); if ("throw" === i.type) return e.method = "throw", e.arg = i.arg, e.delegate = null, f; var a = i.arg; return a ? a.done ? (e[r.r] = a.value, e.next = r.n, "return" !== e.method && (e.method = "next", e.arg = t), e.delegate = null, f) : a : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, f); } function w(t) { this.tryEntries.push(t); } function m(r) { var e = r[4] || {}; e.type = "normal", e.arg = t, r[4] = e; } function Context(t) { this.tryEntries = [[-1]], t.forEach(w, this), this.reset(!0); } function x(r) { if (null != r) { var e = r[i]; if (e) return e.call(r); if ("function" == typeof r.next) return r; if (!isNaN(r.length)) { var o = -1, a = function e() { for (; ++o < r.length;) if (n.call(r, o)) return e.value = r[o], e.done = !1, e; return e.value = t, e.done = !0, e; }; return a.next = a; } } throw new TypeError(typeof r + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, c(v, "constructor", GeneratorFunctionPrototype), c(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = c(GeneratorFunctionPrototype, u, "GeneratorFunction"), r.isGeneratorFunction = function (t) { var r = "function" == typeof t && t.constructor; return !!r && (r === GeneratorFunction || "GeneratorFunction" === (r.displayName || r.name)); }, r.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, c(t, u, "GeneratorFunction")), t.prototype = Object.create(v), t; }, r.awrap = function (t) { return { __await: t }; }, g(AsyncIterator.prototype), c(AsyncIterator.prototype, a, function () { return this; }), r.AsyncIterator = AsyncIterator, r.async = function (t, e, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(h(t, e, n, o), i); return r.isGeneratorFunction(e) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, g(v), c(v, u, "Generator"), c(v, i, function () { return this; }), c(v, "toString", function () { return "[object Generator]"; }), r.keys = function (t) { var r = Object(t), e = []; for (var n in r) e.unshift(n); return function t() { for (; e.length;) if ((n = e.pop()) in r) return t.value = n, t.done = !1, t; return t.done = !0, t; }; }, r.values = x, Context.prototype = { constructor: Context, reset: function reset(r) { if (this.prev = this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(m), !r) for (var e in this) "t" === e.charAt(0) && n.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0][4]; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(r) { if (this.done) throw r; var e = this; function n(t) { a.type = "throw", a.arg = r, e.next = t; } for (var o = e.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i[4], u = this.prev, c = i[1], h = i[2]; if (-1 === i[0]) return n("end"), !1; if (!c && !h) throw Error("try statement without catch or finally"); if (null != i[0] && i[0] <= u) { if (u < c) return this.method = "next", this.arg = t, n(c), !0; if (u < h) return n(h), !1; } } }, abrupt: function abrupt(t, r) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var n = this.tryEntries[e]; if (n[0] > -1 && n[0] <= this.prev && this.prev < n[2]) { var o = n; break; } } o && ("break" === t || "continue" === t) && o[0] <= r && r <= o[2] && (o = null); var i = o ? o[4] : {}; return i.type = t, i.arg = r, o ? (this.method = "next", this.next = o[2], f) : this.complete(i); }, complete: function complete(t, r) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && r && (this.next = r), f; }, finish: function finish(t) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var e = this.tryEntries[r]; if (e[2] === t) return this.complete(e[4], e[3]), m(e), f; } }, catch: function _catch(t) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var e = this.tryEntries[r]; if (e[0] === t) { var n = e[4]; if ("throw" === n.type) { var o = n.arg; m(e); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(r, e, n) { return this.delegate = { i: x(r), r: e, n: n }, "next" === this.method && (this.arg = t), f; } }, r; }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pdt = exports.validate = exports.req = exports.app = undefined;
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
exports.dispatch = dispatch;
exports.jumpToLogin = jumpToLogin;
exports.lock = lock;
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
var _reactDom = require("react-dom");
var _reactDom2 = _interopRequireDefault(_reactDom);
var _reactRedux = require("react-redux");
var _redux = require("redux");
var _reduxThunk = require("redux-thunk");
var _reduxThunk2 = _interopRequireDefault(_reduxThunk);
var _developmentOnly = require("redux-devtools-extension/developmentOnly");
var _reactRouterDom = require("react-router-dom");
var _result = require("lodash/fp/result");
var _result2 = _interopRequireDefault(_result);
require("isomorphic-fetch");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }
        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }
      return step("next");
    });
  };
}
var app = exports.app = {
  models: [],
  store: {},
  reducers: {},
  middleware: [],
  pages: [],
  apiList: {},
  getStore: function getStore() {
    return this.store;
  },
  getApi: function getApi() {
    return this.apiList;
  },
  getReducers: function getReducers(reducers) {
    return (0, _redux.combineReducers)(reducers);
  },
  getRouter: function getRouter() {
    function getExact(path) {
      return path === "/" ? true : false;
    }
    return _react2.default.createElement(_reactRouterDom.BrowserRouter, null, _react2.default.createElement(_reactRouterDom.Switch, null, this.pages.map(function (page) {
      return _react2.default.createElement(_reactRouterDom.Route, {
        key: page.path,
        path: page.path,
        exact: getExact(page.path),
        component: page.component.default
      });
    })));
  },
  getProvider: function getProvider(reducers) {
    this.store = (0, _redux.createStore)(this.getReducers(reducers), (0, _developmentOnly.composeWithDevTools)((0, _redux.applyMiddleware)(_reduxThunk2.default)));
    return _react2.default.createElement(_reactRedux.Provider, {
      store: this.store
    }, this.getRouter());
  },
  render: function render(reducers) {
    _reactDom2.default.render(this.getProvider(reducers), document.getElementById("root"));
  },
  start: function start() {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;
    try {
      for (var _iterator = this.models[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var m = _step.value;
        this.reducers[m.default.name] = m.default.reducers;
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
    this.render(this.reducers);
  },
  model: function model(appModel) {
    this.models.push(appModel);
  },
  page: function page(appPage) {
    this.pages.push(appPage);
  },
  api: function api(appApi) {
    this.apiList[appApi.name] = appApi.path;
  },
  getURL: function getURL(query) {
    if ((typeof query === "undefined" ? "undefined" : _typeof(query)) !== "object") {
      console.error('query should be object, example:{api:"path"}');
      return;
    }
    var path = (0, _result2.default)([query.api], this.apiList);
    if (!query.hasOwnProperty("params")) return path;
    if (query.params === undefined) return path;
    return path + "/" + query.params;
  },
  getApiData: function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(query, method) {
      var data, options, dataJSON;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              data = void 0;
              options = void 0;
              if (!(method === "GET")) {
                _context.next = 9;
                break;
              }
              options = {
                credentials: query.hasOwnProperty("credentials") && query.credentials || "include",
                method: method,
                cache: "no-cache",
                headers: query.hasOwnProperty("headers") && query.headers || {
                  "content-type": "application/json"
                }
              };
              _context.next = 6;
              return fetch(this.getURL(query), options);
            case 6:
              data = _context.sent;
              _context.next = 13;
              break;
            case 9:
              options = {
                body: query.hasOwnProperty("body") && JSON.stringify(query.body) || null,
                credentials: query.hasOwnProperty("credentials") && query.credentials || "include",
                method: method,
                cache: "no-cache",
                headers: query.hasOwnProperty("headers") && query.headers || {
                  "content-type": "application/json"
                }
              };
              _context.next = 12;
              return fetch(this.getURL(query), options);
            case 12:
              data = _context.sent;
            case 13:
              _context.next = 15;
              return data.json();
            case 15:
              dataJSON = _context.sent;
              return _context.abrupt("return", dataJSON);
            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));
    function getApiData(_x, _x2) {
      return _ref.apply(this, arguments);
    }
    return getApiData;
  }()
};
function dispatch(action) {
  return app.getStore().dispatch(action);
}
var req = exports.req = {
  post: function post(query) {
    return app.getApiData(query, "POST");
  },
  get: function get(query) {
    return app.getApiData(query, "GET");
  },
  put: function put(query) {
    return app.getApiData(query, "PUT");
  },
  patch: function patch(query) {
    return app.getApiData(query, "PATCH");
  },
  delete: function _delete(query) {
    return app.getApiData(query, "DELETE");
  }
};
var validate = exports.validate = {
  email: function email(_email, fn) {
    var rule = new RegExp("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,6}$");
    if (_email === "") return null;
    if (!rule.test(_email)) return null;
    return fn;
  }
};
function jumpToLogin(casHostUrl) {
  window.location.href = casHostUrl + "/cas/login?region=tw&locale=zh_TW&service=" + encodeURIComponent(window.location.href);
}
function lock(isLock, fn) {
  if (typeof isLock !== "boolean") {
    console.error("isLock should be boolean!");
    return;
  }
  if (isLock) return null;
  return fn;
}
var pdt = exports.pdt = {
  getSumQty: function getSumQty(qty) {
    if (qty.stock === "NaN") return 0;
    return qty.stock - qty.purchase;
  },
  getPoQty: function getPoQty(cartItems, productId) {
    var count = 0;
    if (cartItems === undefined) return 0;
    if (productId === undefined) return 0;
    cartItems.forEach(function (item) {
      if (item.cbu === productId) {
        count++;
      }
    });
    return count;
  },
  isOneInStock: function isOneInStock(qty, fn) {
    return this.getSumQty(qty) != 1 && fn || null;
  },
  isOutOfStock: function isOutOfStock(qty, fn) {
    return this.getSumQty(qty) > 0 && fn || null;
  },
  stringToHtml: function stringToHtml(string) {
    var htmlObject = _react2.default.createElement("p", {
      dangerouslySetInnerHTML: {
        __html: string
      }
    });
    return htmlObject;
  },
  getArrWithAvaliable: function getArrWithAvaliable(baseLine, avaList) {
    var arrWithAvaliableState = baseLine.map(function (item) {
      var status = "notAvaliable";
      if (avaList.some(function (element) {
        return element.code === item.code;
      })) {
        status = "avaliable";
      }
      return {
        code: item.code,
        name: item.name,
        status: status
      };
    });
    return arrWithAvaliableState;
  }
};